import { useLocalizationContext } from '@im/react-localization';
import { useApiQuery } from '../query';

export type VideoMapper = {
  videos: Video[];
};
export type Video = {
  embedCode: string;
  videoFile: string;
  videoType: string;
};

export function useWelcomeVideoURL() {
  const { locale } = useLocalizationContext();
  const query = useApiQuery<VideoMapper>(
    `/cms/v1/videos?PageName=Welcome&Zone=Top&typelang=${locale}`
  );
  return query;
}
